"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Prism = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const prismjs_1 = __importDefault(require("prismjs"));
require("prismjs/components/prism-json");
require("prismjs/components/prism-sql");
const react_1 = require("react");
const provider_1 = require("../themes/provider");
exports.default = Prism;
function Prism(props) {
    const ref = (0, react_1.useRef)(null);
    const theme = (0, provider_1.useDecodableTheme)();
    const Wrapper = props.inline ? "span" : "pre";
    (0, react_1.useLayoutEffect)(() => {
        prismjs_1.default.highlightElement(ref.current);
    }, [props.children]);
    return ((0, jsx_runtime_1.jsx)(Wrapper, Object.assign({ className: `language-${props.language}`, style: Object.assign({ margin: 0, fontFamily: theme.typography.code.fontFamily }, props.style) }, { children: (0, jsx_runtime_1.jsx)("code", Object.assign({ ref: ref }, { children: props.children })) })));
}
exports.Prism = Prism;
